export const convertLeadToken = (authToken: string) => {
  let encodedToken = encodeURIComponent(authToken);
  encodedToken = encodedToken?.replace(new RegExp("%20", "g"), "%2B");
  const decodedToken = decodeURIComponent(encodedToken);
  return decodedToken;
}